module.exports = __webpack_public_path__ + "img/facebook-orange.4bbb2faf.svg";